// Importar las dependencias necesarias
import { createRouter, createWebHistory } from "vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Importar los componentes necesarios
import AdminLayout from "../components/layouts/AdminLayout.vue";
import CrearCuentaPaciente from "../components/views/paciente/CrearCuentaPaciente.vue";
import EnfermeroLayout from "../components/layouts/EnfermeroLayout.vue";
import DocumentosPaciente from "../components/views/paciente/DocumentosPaciente.vue";
import PacienteLayout from "../components/layouts/PacienteLayout.vue";
import Login from "../components/layouts/Login.vue";
import CalendarioView from "../components/views/CalendarioView.vue";
import GestionInventario from "../components/views/GestionInventario.vue";
import AsignacionMedicamentos from "../components/views/AsignacionMedicamentos.vue";
import CrearEnfermero from "../components/views/CrearEnfermero.vue";
import CrearPaciente from "../components/views/CrearPaciente.vue";
import FinanzasAdmin from "../components/views/FinanzasAdmin.vue";
import GPSAdmin from "../components/views/GPSAdmin.vue";
import CitasCompletadas from "../components/views/CitasCompletadas.vue"; // Nueva importación
import CitasPaciente from "../components/views/paciente/CitasPaciente.vue";
import InformacionPaciente from "../components/views/paciente/InformacionPaciente.vue";
import SolicitudCitas from "../components/views/SolicitudCitas.vue";
import FinanzasPaciente from "../components/views/paciente/FinanzasPaciente.vue";
// **Estas son las importaciones que faltan**
import MiHorario from "@/components/views/enfermero/MiHorario.vue";
import MigrarImagenes from "@/components/views/MigrarImagenes.vue";

import PacientesEnfermero from "../components/views/PacientesEnfermero.vue";
import PerfilSalud from "../components/views/paciente/PerfilSalud.vue";
import ActividadFisica from "../components/views/paciente/ActividadFisica.vue";
import ProgresoSalud from "../components/views/paciente/ProgresoSalud.vue"; // Verifica la ruta exacta
import SolicitarPaciente from "@/components/views/paciente/SolicitarPaciente.vue";
import SolicitudCompletada from "@/components/views/paciente/SolicitudCompletada.vue";
import PacientesProspectos from "@/components/views/PacientesProspectos.vue";
import TimePicker from "@/components/views/paciente/TimePicker.vue";
import RecuperarCuenta from "@/components/views/paciente/RecuperarCuenta.vue";
import RecuperarCompletado from "@/components/views/paciente/RecuperarCompletado.vue";
// import TwilioComponent from '@/components/views/twilioTest.vue';
import LandingPage from "@/components/views/LandingPage.vue";
import POSView from "@/components/views/POSView.vue";
import AdminHorarios from "@/components/views/AdminHorarios.vue";

// Definir las rutas
const routes = [
  {
    path: "/registro/crear-cuenta",
    name: "crear-cuenta-simple",
    component: CrearCuentaPaciente,
    props: true,
    meta: { public: true },
  },
  {
    path: "/registro/crear-cuenta/:prospectoId",
    name: "crear-cuenta",
    component: CrearCuentaPaciente,
    props: true,
    meta: { public: true },
  },
  {
    path: "/politica-cancelacion",
    name: "PoliticaCancelacion",
    component: () => import("@/components/views/paciente/politica-cancelacion.vue"),
    meta: { public: true },
  },
  

  {
    path: "/recuperar-cuenta",
    component: RecuperarCuenta,
  },
  {
    path: "/recuperar-completado",
    component: RecuperarCompletado,
  },
  {
    path: "/time-picker",
    component: TimePicker,
  },
  {
    path: "/solicitar-paciente",
    component: SolicitarPaciente,
  },
  {
    path: "/solicitud-completada",
    component: SolicitudCompletada,
  },
  {
    path: "/crear-cuenta/:uid",
    name: "crear-cuenta-desde-enlace",
    component: CrearCuentaPaciente,
    props: true,
    meta: { public: true },
  },

  {
    path: "/tienda",
    name: "ClienteTienda",
    component: () => import("@/components/views/ClienteTienda.vue"),
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import("@/components/ecommerce/CheckoutPage.vue"),
  },

  {
    path: "/checkout/success",
    name: "CheckoutSuccess",
    component: () => import("@/components/views/CheckoutSuccess.vue"),
  },
  {
    path: "/migrar-imagenes",
    name: "MigrarImagenes",
    component: MigrarImagenes,
    meta: { requiereAdmin: true }, // opcional si tienes control de acceso
  },

  {
    path: "/admin/banner",
    name: "AdminBanner",
    component: () => import("@/components/AdminBanner.vue"),
    meta: { requiresAuth: true, role: "admin" },
  },

  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true, role: "admin" },
    children: [
      {
        path: "calendario",
        component: CalendarioView,
        meta: {
          requiresAuth: true,
          role: ["admin", "supervisor", "enfermero", "esteticista"],
        },
      },
      {
        path: "/pos",
        name: "POS",
        component: POSView,
        meta: { requiresAuth: true, role: ["admin", "supervisor"] },
      },
      {
        path: "prospectos",
        component: PacientesProspectos,
        meta: { requiresAuth: true, role: ["admin", "supervisor"] },
      },
      {
        path: "horarios",
        component: AdminHorarios,
        meta: { requiresAuth: true, role: ["admin", "supervisor"] },
      },
      
      {
        path: "crear-enfermero",
        component: CrearEnfermero,
        meta: { requiresAuth: true, role: ["admin", "supervisor"] },
      },
      {
        path: "crear-paciente",
        component: CrearPaciente,
        meta: { requiresAuth: true, role: ["admin", "supervisor"] },
      },

      { path: "inventario", component: GestionInventario },
      { path: "asignacion", component: AsignacionMedicamentos },

      { path: "finanzas", component: FinanzasAdmin },
      { path: "gps", component: GPSAdmin },
      { path: "citas-completadas", component: CitasCompletadas },
      { path: "solicitud-citas", component: SolicitudCitas },
      {
        path: "revisar-solicitudes-dosis",
        component: () =>
          import("@/components/views/RevisarSolicitudesDosis.vue"),
      },
    ],
  },
  {
    path: "/enfermero",
    component: EnfermeroLayout,
    redirect: "/enfermero/calendario",
    children: [
      {
        path: "calendario",
        component: CalendarioView,
        meta: { requiresAuth: true, role: "enfermero" },
      },
      {
        path: "crear-paciente",
        component: CrearPaciente,
        meta: { requiresAuth: true, role: "enfermero" },
      },

      {
        path: "pacientes",
        component: PacientesEnfermero,
        meta: { requiresAuth: true, role: "enfermero" },
      },
      {
        path: "mi-horario",
        component: MiHorario,
        meta: { requiresAuth: true, role: "enfermero" },
      },

      { path: ":id/crear-cuenta", component: CrearCuentaPaciente },
    ],
  },
  {
    path: "/paciente/:pacienteId",
    component: PacienteLayout,
    props: true,
    children: [
      {
        path: '',
        redirect: (to) => `/paciente/${to.params.pacienteId}/citas`
      },
      {
        path: "citas",
        component: CitasPaciente,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "informacion",
        component: InformacionPaciente,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "progreso-salud",
        component: ProgresoSalud,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "perfil-salud",
        component: PerfilSalud,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "actividad-fisica",
        component: ActividadFisica,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "documentos",
        component: DocumentosPaciente,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "finanzas",
        component: FinanzasPaciente,
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "aumento-dosis",
        component: () => import("@/components/views/paciente/AumentoDosis.vue"),
        meta: { requiresAuth: true, role: "paciente" },
      },
      {
        path: "recomendaciones",
        component: () => import("@/components/views/paciente/PacienteRecomendaciones.vue"),
        meta: { requiresAuth: true, role: "paciente" },
      }
    ]
  },
  

  {
    path: "/",
    component: LandingPage,
  },
  {
    path: "/login",
    component: Login,
  },
];

// Configuración del router con control de acceso
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 🔧 Manejo automático si falla la carga de un chunk CSS/JS
router.onError((error) => {
  const pattern = /Loading chunk \d+ failed|ChunkLoadError/;
  if (pattern.test(error.message)) {
    window.location.reload();
  }
});

const auth = getAuth();

function waitForAuthState() {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe(); // Deja de escuchar después de la primera respuesta
      resolve(user);
    });
  });
}

router.beforeEach(async (to, from, next) => {
  //  Evita el bloqueo por “requiresAuth”
  if (
    to.name === "crear-cuenta" ||
    to.path.startsWith("/registro/crear-cuenta/")
  ) {
    return next();
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const role = to.meta.role;
  const user = await waitForAuthState();

  if (requiresAuth) {
    if (!user) return next("/login");
    let userDoc;
    const allowedRoles = Array.isArray(role) ? role : [role];

    userDoc = await getDoc(doc(db, "users", user.uid));
    if (!userDoc.exists()) {
      const altCollections = {
        paciente: "pacientes",
        enfermero: "enfermeros",
        esteticista: "enfermeros",
      };
      for (const r of allowedRoles) {
        if (altCollections[r]) {
          const altDoc = await getDoc(doc(db, altCollections[r], user.uid));
          if (altDoc.exists()) {
            userDoc = altDoc;
            break;
          }
        }
      }
    }

    if (userDoc.exists()) {
      const userRole = userDoc.data().role;
      // Handle both 'enfermero' and 'esteticista' roles as the same
      if (
        (userRole === "esteticista" && allowedRoles.includes("enfermero")) ||
        (userRole === "enfermero" && allowedRoles.includes("esteticista")) ||
        allowedRoles.includes(userRole)
      ) {
        return next();
      }
    }
    return next("/login");
  } else {
    return next();
  }
});
export default router;
